import _slicedToArray from "/home/runner/work/sonos-web-app-tech-blog/sonos-web-app-tech-blog/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import { debounce } from "@sonos-inc/web-ui-utils";
import styled from "@sonos-inc/web-ui-styled";
import css from "@sonos-inc/web-ui-css";
import { AspectRatioBox } from "./aspectRatioBox";
import { jsx as ___EmotionJSX } from "@emotion/core";
var widths = [64, 128, 192, 256, 320, 384, 440, 512, 640, 750, 828, 1080, 1200, 1920, 2048, 3840]; // LQIP = Low Quality Image Placeholder (blurred image)

var ImageContainer = styled(AspectRatioBox)(function (_ref) {
  var bgOpacity = _ref.bgOpacity,
      lqipUri = _ref.lqipUri,
      lqipColor = _ref.lqipColor;
  return css({
    "&::before": {
      transition: "opacity 1s ease-in 0.5s",
      opacity: bgOpacity || 0,
      backgroundImage: lqipUri ? "url(\"" + lqipUri + "\")" : null,
      backgroundColor: lqipColor,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      filter: "blur(1em)"
    },
    "& > img": {
      top: 0,
      left: 0,
      height: "auto",
      width: "auto",
      objectFit: "contain",
      objectPosition: "left",
      minWidth: "100%",
      maxHeight: "100%",
      transition: "opacity 1s ease-in"
    },
    "& > figcaption": {
      position: "relative",
      marginTop: "medium",
      marginLeft: "huge"
    }
  });
}).withComponent("figure", {
  target: "e1fe4x7y0",
  label: "ImageContainer"
});

function generateSrcSet(src) {
  return widths.map(function (w) {
    return src + "?w=" + w + "&q=80 " + w + "w";
  }).join(", ");
}

function resolveDimensions(image) {
  var _image$clientWidth, _image$clientHeight;

  return {
    width: (_image$clientWidth = image.clientWidth) != null ? _image$clientWidth : 0,
    height: (_image$clientHeight = image.clientHeight) != null ? _image$clientHeight : 0
  };
}

var StyledImage = styled.img(function (props) {
  return css({
    opacity: props.opacity
  });
});
export var fallbackImage = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
export var Image = function Image(_ref2) {
  var src = _ref2.src,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? "unknown image" : _ref2$alt,
      lqipUri = _ref2.lqipUri,
      aspectRatio = _ref2.aspectRatio,
      caption = _ref2.caption,
      width = _ref2.width,
      height = _ref2.height,
      onLoad = _ref2.onLoad,
      onError = _ref2.onError,
      props = _objectWithoutPropertiesLoose(_ref2, ["src", "alt", "ref", "lqipUri", "aspectRatio", "caption", "width", "height", "onLoad", "onError"]);

  var ImageRef = React.useRef(null);

  var _React$useState = React.useState({
    width: 0,
    height: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dimensions = _React$useState2[0],
      setDimensions = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasLoaded = _React$useState4[0],
      setHasLoaded = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      hasError = _React$useState6[0],
      setHasError = _React$useState6[1];

  var srcSet = React.useMemo(function () {
    return src ? generateSrcSet(src) : fallbackImage;
  }, [src]);
  React.useEffect(function () {
    var calculate = function calculate() {
      if (ImageRef.current) {
        setDimensions(resolveDimensions(ImageRef.current));
      }
    };

    var debouncedCalculate = debounce(calculate, 250);
    window.addEventListener("resize", debouncedCalculate);
    window.addEventListener("orientationchange", debouncedCalculate);
    calculate();
    return function () {
      window.removeEventListener("resize", debouncedCalculate);
      window.removeEventListener("orientationchange", debouncedCalculate);
    };
  }, [src]);
  var handleImageLoad = React.useCallback(function (event) {
    if (onLoad) onLoad(event);
    setHasLoaded(true);
    setHasError(false);
  }, [onLoad]);
  var handleImageError = React.useCallback(function (event) {
    if (onError) onError(event);
    setHasError(true);
  }, [onError]);
  var adjustedAspectRatio = dimensions.height && hasLoaded ? dimensions.width / dimensions.height : aspectRatio;
  return ___EmotionJSX(ImageContainer, {
    aspectRatio: adjustedAspectRatio,
    lqipUri: lqipUri,
    width: width != null ? width : "100%",
    height: height,
    bgOpacity: hasLoaded ? 0 : 1,
    "data-image-loaded": hasLoaded,
    "data-image-errored": hasError ? true : null
  }, ___EmotionJSX(StyledImage, _extends({
    ref: ImageRef,
    sizes: dimensions.width + "px",
    srcSet: srcSet,
    alt: alt,
    opacity: hasLoaded ? 1 : 0
  }, props, {
    onLoad: handleImageLoad,
    onError: handleImageError
  })), caption && ___EmotionJSX("figcaption", null, caption));
};